import { Injectable } from '@angular/core';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { SessionService } from '@monsido/core/session/session.service';
import { CollectionInterface } from '@monsido/angular-shared-components';
import { BaseRepo } from '@client/app/services/api/base-repo/base-repo';
import {
    PagePerformanceAssignedProfile,
} from '@client/app/models/page-performance/assigned-profile/assigned-profile.model';

@Injectable({
    providedIn: 'root',
})
export class AssignedProfilesRepoService extends BaseRepo {
    constructor (
        private apiService: ApiService,
        protected sessionService: SessionService,
    ) {
        super();
    }

    getAll (params: Record<string, any> = {}, contextToken?: any): Promise<CollectionInterface<PagePerformanceAssignedProfile>> {
        params.group_id = this.sessionService.getGroupId(params);
        return this.apiService.get('performance/assigned_profiles', params, {}, contextToken).then(res => this.toModels(res));
    }

    update (profile: PagePerformanceAssignedProfile, params: Record<string, any> = {}): Promise<PagePerformanceAssignedProfile> {
        return this.apiService.patch(`performance/assigned_profiles/${profile.id}`, profile).then(res => this.toModel(res));
    }

    destroy (profile: PagePerformanceAssignedProfile, params: Record<string, any> = {}): Promise<void> {
        params.group_id = this.sessionService.getGroupId(params);
        return this.apiService.delete(`performance/assigned_profiles/${profile.id}`, params);
    }

    create (profile: Partial<PagePerformanceAssignedProfile>, contextToken?: any): Promise<PagePerformanceAssignedProfile> {
        return this.apiService.post('performance/assigned_profiles', profile, contextToken).then(res => this.toModel(res));
    }

    // PROTECTED

    private toModels (models: any): CollectionInterface<PagePerformanceAssignedProfile> {
        const assignedProfiles: CollectionInterface<PagePerformanceAssignedProfile> = models.map(model => this.toModel(model));
        assignedProfiles.total = models.total;
        assignedProfiles.currentPage = models.currentPage;
        assignedProfiles.perPage = models.perPage;
        return assignedProfiles;
    }

    private toModel (model: any): PagePerformanceAssignedProfile {
        return new PagePerformanceAssignedProfile(model);
    }
}
